import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const UsersGlyph = /*#__PURE__*/createElement("g", {
  id: "users"
}, /*#__PURE__*/createElement("path", {
  d: "M33.8 58.1c0-1 .1-1.8.5-2.9-3.5.3-3.2.2-3.6.2-3.1 0-13.3-.4-13.3-5.9 0-4.5 6.2-13.6 13.3-13.6 5.4 0 9.6 4.5 11.6 9 .8-.7 1.6-1.3 2.4-1.9-2.1-4.1-5.3-7.5-9.8-9.3 3.3-1.5 5.6-4.8 5.6-8.6 0-5.2-4.3-9.5-9.5-9.5s-9.5 4.3-9.5 9.5c0 3.7 2.1 6.9 5.2 8.5-7 2.4-12.4 10.6-12.4 15.9 0 5.6 6 9.6 16.3 8.9 1.5-.2-.4 0 3.2-.3.1 0 0 0 0 0zm-9.2-33c0-3.6 2.9-6.5 6.5-6.5s6.5 2.9 6.5 6.5-2.9 6.5-6.5 6.5c-3.6-.1-6.5-3-6.5-6.5z"
}), /*#__PURE__*/createElement("path", {
  d: "M57.6 43.8c3.3-1.5 5.6-4.8 5.6-8.6 0-5.2-4.3-9.5-9.5-9.5s-9.5 4.3-9.5 9.5c0 3.7 2.1 6.9 5.2 8.5C42.5 46 37 54.3 37 59.6c0 5.6 5.9 8.9 16.3 8.9s16.3-3.2 16.3-8.9c0-5.2-5.2-13.2-12-15.8zm-10.4-8.6c0-3.6 2.9-6.5 6.5-6.5s6.5 2.9 6.5 6.5-2.9 6.5-6.5 6.5c-3.6-.1-6.5-3-6.5-6.5zm6.1 30.2c-3.1 0-13.3-.4-13.3-5.8C40 55.1 46.2 46 53.3 46s13.3 9.1 13.3 13.6c0 5.4-10.2 5.8-13.3 5.8z"
}));
const Users = createSvg({
  name: 'users',
  path: UsersGlyph
});

export default Users;
export { UsersGlyph };
